import { render, staticRenderFns } from "./ButtonTabs.vue?vue&type=template&id=6d9e640e&scoped=true&"
import script from "./ButtonTabs.vue?vue&type=script&lang=ts&"
export * from "./ButtonTabs.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTabs.vue?vue&type=style&index=0&id=6d9e640e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e640e",
  null
  
)

export default component.exports